import { systemError } from 'feature-components/system-error-alert';
import { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';

export const statusesOfReviewMarks = [
  MarkStatus.NeedsReview,
  MarkStatus.InReview,
  MarkStatus.FurtherEscalated
];

export function statusesOfNonReviewMarks(): MarkStatus[] {
  return Object.values(MarkStatus).filter(
    (status) => ![MarkStatus.Assigned].concat(statusesOfReviewMarks).includes(status)
  );
}

export function markStatusMessage(markStatus: MarkStatus): string {
  const howToResumeEditingMessage =
    'Marking Admins can make changes. Editing of this mark by the Active Marker can resume when a Marking Admin sets the status to "Returned for Marking" or reassigns it.';
  const canBeModifiedMessage = (action: 'created' | 'edited'): string =>
    `Mark can be ${action} by the Active Marker or a Marking Admin.`;
  const canBeEditedByChangingStatusMessage = `Mark can be edited by a Marking Admin changing the status back to "In Progress".`;

  switch (markStatus) {
    case MarkStatus.Assigned:
      return `The response has been assigned to a marker, but a mark has not been created. ${canBeModifiedMessage('created')}`;
    case MarkStatus.InProgress:
      return `Marking has started and this mark is in a draft state. ${canBeModifiedMessage('edited')}`;
    case MarkStatus.NeedsReview:
      return `It has been requested that this mark is looked at by a Marking Admin. ${howToResumeEditingMessage}`;
    case MarkStatus.InReview:
      return `This mark is being looked at by a Marking Admin. ${howToResumeEditingMessage}`;
    case MarkStatus.ReturnedForMarking:
      return `This mark has been reviewed and returned to the Active Marker for further marking. ${canBeModifiedMessage('edited')}`;
    case MarkStatus.FurtherEscalated:
      return `This mark is no longer being looked at by a Marking Admin and has been escalated. ${howToResumeEditingMessage}`;
    case MarkStatus.Reassigned:
      return `This mark has been reassigned to a new Active Marker. ${canBeModifiedMessage('edited')}`;
    case MarkStatus.FinishedSuccess:
      return `This mark has been submitted, so it can no longer be edited. ${canBeEditedByChangingStatusMessage}`;
    case MarkStatus.FinishedFailure:
      return `This response could not be marked successfully. ${canBeEditedByChangingStatusMessage}`;
    default:
      return systemError('Mark Status is not defined in the system.');
  }
}
